import { useMemo, useState } from "react";

const ClassRoomDetailsDashboard = ({ data = [] }) => {
    const [selectedOrganization, setSelectedOrganization] = useState("All");
    const [selectedLocation, setSelectedLocation] = useState("All");
    const [selectedYear, setSelectedYear] = useState("All");
    const [selectedClassroom, setSelectedClassroom] = useState("All");

    const organizations = useMemo(
        () => [...new Set(data.map(item => item.classroom?.organization?.name).filter(Boolean))],
        [data]
    );

    const locations = useMemo(
        () => [...new Set(data.map(item => item.location).filter(Boolean))],
        [data]
    );

    const years = useMemo(
        () => [...new Set(data.map(item => item.year).filter(Boolean))],
        [data]
    );

    const classrooms = useMemo(
        () => [...new Set(data.map(item => item.classroom?.name).filter(Boolean))],
        [data]
    );

    const filteredData = useMemo(() => {
        return data.filter(item => {
            const matchesOrganization =
                selectedOrganization === "All" ||
                item.classroom?.organization?.name === selectedOrganization;

            const matchesLocation =
                selectedLocation === "All" || item.location === selectedLocation;

            const matchesYear =
                selectedYear === "All" || String(item.year) === String(selectedYear);

            const matchesClassroom =
                selectedClassroom === "All" || item.classroom?.name === selectedClassroom;

            return matchesOrganization && matchesLocation && matchesYear && matchesClassroom;
        });
    }, [data, selectedOrganization, selectedLocation, selectedYear, selectedClassroom]);

    return (
        <div dir="rtl" className="w-[85vw] max-w-6xl p-4 text-gray-800">
            <h1 className="mb-4 text-xl font-bold text-center">تفاصيل غرف التدريب</h1>

            {/* Filters */}
            <div className="mb-4 grid grid-cols-2 gap-3 md:grid-cols-4">
                <div>
                    <label className="mb-1 block text-sm font-semibold">الجهة</label>
                    <select
                        className="w-full rounded border p-2 text-sm"
                        value={selectedOrganization}
                        onChange={(e) => setSelectedOrganization(e.target.value)}
                    >
                        <option value="All">الكل</option>
                        {organizations.map(org => (
                            <option key={org} value={org}>{org}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label className="mb-1 block text-sm font-semibold">المكان</label>
                    <select
                        className="w-full rounded border p-2 text-sm"
                        value={selectedLocation}
                        onChange={(e) => setSelectedLocation(e.target.value)}
                    >
                        <option value="All">الكل</option>
                        {locations.map(loc => (
                            <option key={loc} value={loc}>{loc}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label className="mb-1 block text-sm font-semibold">السنة</label>
                    <select
                        className="w-full rounded border p-2 text-sm"
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(e.target.value)}
                    >
                        <option value="All">الكل</option>
                        {years.map(y => (
                            <option key={y} value={y}>{y}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label className="mb-1 block text-sm font-semibold">الغرفة</label>
                    <select
                        className="w-full rounded border p-2 text-sm"
                        value={selectedClassroom}
                        onChange={(e) => setSelectedClassroom(e.target.value)}
                    >
                        <option value="All">الكل</option>
                        {classrooms.map(c => (
                            <option key={c} value={c}>{c}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Table */}
            <div className="overflow-x-auto rounded-xl border">
                <table className="w-full border-collapse text-center text-sm">
                    <thead>
                        <tr className="bg-sky-600 text-white">
                            <th className="border p-2">م</th>
                            <th className="border p-2">الاسم</th>
                            <th className="border p-2">المكان</th>
                            <th className="border p-2">سليم</th>
                            <th className="border p-2">غير سليم</th>
                            <th className="border p-2">السبب</th>
                            <th className="border p-2">السنة</th>
                            <th className="border p-2">الغرفة</th>
                            <th className="border p-2">الجهة</th>
                        </tr>
                    </thead>

                    <tbody>
                        {filteredData.length > 0 ? (
                            filteredData.map((item, index) => (
                                <tr key={item.id ?? index} className={index % 2 === 0 ? "bg-white" : "bg-slate-50"}>
                                    <td className="border p-2">{index + 1}</td>
                                    <td className="border p-2 font-bold">{item.name || "-"}</td>
                                    <td className="border p-2">{item.location || "-"}</td>
                                    <td className="border p-2 text-green-600 font-bold">{item.working ?? 0}</td>
                                    <td className="border p-2 text-red-600 font-bold">{item.not_working ?? 0}</td>
                                    <td className="border p-2">{item.reason || "-"}</td>
                                    <td className="border p-2">{item.year || "-"}</td>
                                    <td className="border p-2">{item.classroom?.name || "-"}</td>
                                    <td className="border p-2">{item.classroom?.organization?.name || "-"}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={9} className="border p-4 text-gray-500">لا توجد بيانات</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ClassRoomDetailsDashboard;
